<div
  class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper"
  [class.ag-checked]="isCheckboxSelected"
  (click)="onCheckboxClicked()"
></div>
